<template>
    <span>
        <div class="vertical-timeline-icon blue-bg">
            <i class="fa fa-file-movie-o"></i>
        </div>

        <div class="vertical-timeline-content">
            <h5>Просмотр видео</h5>
            <p>&laquo;{{action.title}}&raquo;</p>
            <router-link :to="action.link" class="btn btn-sm btn-success"> Подробнее</router-link>
            <span class="vertical-date">
                {{ action.date }}
                <small>{{ action.time }}</small>
            </span>
        </div>
    </span>
</template>

<script>
    export default {
        name: "ActionsWatch",
        props: ['action']
    }
</script>

<style scoped>

</style>
